import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import classnames from 'classnames'

const Row = (props) => {
  // @todo this could do with a refactor
  return props.content.map((row, idx) => {
    let text

    if (Array.isArray(row.content)) {
      text = row.content.map((col, idx) => {
        let colContent
        let link
        let classes = classnames({
          'col-xs-12': true,
          'col-lg-6': !col.fullWidth,
          'col-lg-12': col.fullWidth
        })

        if (typeof col === 'object' && col !== null) {
          let href
          if (col.cta) {
            href = col.cta.mailto ? 'mailto:' + col.cta.mailto : col.cta.url
            link = (
              <a href={href} className='hoverable-link'>{col.cta.text} —</a>
            )
          }
          colContent = (
            <div className='content content--text text-section'>
              <h4>{col.title}</h4>
              <p>{col.content}</p>
              {link}
            </div>
          )
        } else {
          colContent = ReactHtmlParser(col)
        }

        return (
          <div className={classes} key={idx}>
            {colContent}
          </div>
        )
      })
      text = <div className='row'>{text}</div>
    } else {
      text = ReactHtmlParser(row.content)
    }

    let link
    if (row.cta) {
      const linkSettings = {
        href: row.cta.mailto ? 'mailto:' + row.cta.mailto : row.cta.url,
        className: 'hoverable-link',
        target: row.cta.target
      }
      link = (
        <a {...linkSettings}>{row.cta.text}—</a>
      )
    }

    return (
      <div className='content content--text text-section' key={idx}>
        <h3>{row.title}</h3>
        {text}
        {link}
      </div>
    )
  })
}

export default Row



// WEBPACK FOOTER //
// ./src/components/Page/Content/Text/RowContent/index.js